import "../styles/index.scss";
import {Tooltip} from "bootstrap/dist/js/bootstrap.bundle";
import AOS from 'aos';
import {trigger_card_view, highlight_element} from "../components/pubcard";
import "../components/header";
import '@fontsource/mali';
import '@fontsource/carattere';
import '@fontsource/handlee';
import '@fontsource/caveat';
import '@fontsource/parisienne';
import '@fontsource/satisfy';
import 'aos/dist/aos.css';
import '@fortawesome/fontawesome-free/css/all.css';

window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');
window.document.addEventListener("DOMContentLoaded", function () {
    const paper_authors = document.querySelectorAll(".card-view .notepad .paper-authors");
    paper_authors.forEach((element) => {
       element.innerHTML = element.innerHTML.replaceAll("=", '<a href="#" data-bs-toggle="tooltip" data-bs-title="Co-first author"><sup><svg class="bi"><use xlink:href="#icon-co-first"></use></svg></sup></a>');
       element.innerHTML = element.innerHTML.replaceAll("*", '<a href="#" data-bs-toggle="tooltip" data-bs-title="Co-corresponding author"><sup><svg class="bi"><use xlink:href="#icon-co-corresponding"></use></svg></sup></a>');
    });
    const list_paper_authors = document.querySelectorAll(".list-view .paper-authors");
    list_paper_authors.forEach((element) => {
        element.innerHTML = element.innerHTML.replaceAll("=", '<a href="#" data-bs-toggle="tooltip" data-bs-title="Co-first author"><sup><i class="fa-solid fa-2xs fa-puzzle-piece"></i></sup></a>');
        element.innerHTML = element.innerHTML.replaceAll("*", '<a href="#" data-bs-toggle="tooltip" data-bs-title="Co-corresponding author"><sup><i class="fa-solid fa-2xs fa-envelope-open-text"></i></sup></a>');
    });
    AOS.init();

    //
    trigger_card_view("triggerPubCardView");
    highlight_element("#totalPubCount");
    // citation
    // (async () => {
    //     let pmids = Array.from(document.querySelectorAll(".cite-num-box")).map(ele => ele.dataset.pubmedId);
    //     if (pmids.length > 0) {
    //         let pmid_str = pmids.join(",");
    //         let response = await fetch(`https://icite.od.nih.gov/api/pubs?pmids=${pmid_str}`).then(
    //                 response => response.json()).then(
    //                     r => {
    //                         r.data.forEach(pubmed_obj => {
    //                             if (pubmed_obj.citation_count > 0) {
    //                                 document.querySelector(`#pubmed-badge-${pubmed_obj.pmid}`).href = "https://www.ncbi.nlm.nih.gov/pubmed/?term="+pubmed_obj.cited_by.join('+');
    //                                 document.querySelector(`#pubmed-citation-${pubmed_obj.pmid}`).innerText = "PubMed cites: " + pubmed_obj.citation_count;
    //                             } else {
    //                                 document.querySelector(`#pubmed-badge-${pubmed_obj.pmid}`).remove();
    //                             }
    //                         });
    //                     }
    //                 ).catch(reason => {
    //                     document.querySelector(`#pubmed-badge-${pubmed_obj.pmid}`).remove();
    //                 });
    //     }
    //  })();

    (async () => {
        document.querySelectorAll(".dimensions-cite-num-box").forEach(async(obj) => {
            await fetch(`https://metrics-api.dimensions.ai/doi/${obj.dataset.doi}`).then(
                response => response.json()).then(
                    r => {
                        if (r.times_cited != null && r.times_cited > 0) {
                            if (r.times_cited>1){
                                obj.innerText = `Cited by ${r.times_cited} studies`;
                            }else{
                                obj.innerText = `Cited by ${r.times_cited} study`;
                            }
                        } else {
                            obj.parentNode.parentNode.remove();
                        }
                    }
                ).catch(reason => {
                    obj.parentNode.remove();
            });
        });
    })();

    // (async () => {
    //     document.querySelectorAll(".altmetric-num-box").forEach(async(obj) => {
    //         await fetch(`https://api.altmetric.com/v1/doi/${obj.dataset.doi}`).then(
    //             response => response.json()).then(
    //                 r => {
    //                     if (r.score != null && r.score > 0) {
    //                         obj.innerText = Math.ceil(r.score);
    //                         obj.parentNode.href = r.details_url;
    //                     } else {
    //                         obj.parentNode.remove();
    //                     }
    //                 }
    //             ).catch(reason => {
    //                 obj.parentNode.remove();
    //         });
    //     });
    // })();
    // enable tooltips
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl));
});
